<template>
  <div class="category-filters-mobile">
    <FilterItemMobile
      :label="categoryFilter.label"
      :selected-filter-label="selectedFilterLabel"
      @click.native="categoryFilterAction"
    >
      <template v-if="categoryFilter.isSelectable" #filter-item-content>
        <Radio
          :key="categoryFilter.slugUrl"
          :value="radioValue"
          :native-value="categoryFilter.slugUrl"
          position="right"
          :is-small="true"
          :is-stretched="true"
        >
          {{ radioLabel }}
        </Radio>
      </template>
    </FilterItemMobile>
    <Transition name="slide">
      <div v-if="shouldRender" class="filter-value-list">
        <CategoryFiltersMobile
          v-for="category in categoryFilter.children"
          v-once
          :key="category.id"
          :category-filter="category"
          :tier="tier + 1"
          :entity-type="entityType"
        />
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Radio from '@sephora-asia/inputs-radio/Radio.vue'
import categoryHelper from '../mixins/categoryHelper'
import FilterItemMobile from './FilterItemMobile.vue'

export default {
  name: 'CategoryFiltersMobile',

  components: {
    FilterItemMobile,
    Radio
  },

  mixins: [categoryHelper],

  props: {
    entityType: {
      type: String,
      default: ''
    },

    tier: {
      type: Number,
      required: true
    },

    categoryFilter: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters({
      ancestorCategoryFilterIdsFor:
        'listingPageFilters/ancestorCategoryFilterIdsFor',
      categoryFilterTrail: 'listingPageFilters/categoryFilterTrail',
      currentCategoryFilter: 'listingPageFilters/currentCategoryFilter',
      showViewResultsCTAButton: 'listingPageFilters/showViewResultsCTAButton'
    }),

    radioLabel() {
      return this.categoryFilter.isSelectAll
        ? this.$t('products.filters.selectAll', {
            category: this.categoryFilter.label
          })
        : this.categoryFilter.label
    },

    radioValue() {
      // If a "Select all X" L2 category is selected, select its L3 children as well
      if (
        this.currentCategoryFilter.id === this.categoryFilter.parentId &&
        !this.categoryFilter.isSelectAll
      ) {
        return this.categoryFilter.slugUrl
      }

      return this.currentCategoryFilter.slugUrl
    },

    selectedFilterLabel() {
      if (this.entityType === 'category' || !this.currentCategoryFilter?.id)
        return ''

      if (this.categoryFilter.id === 0) return this.currentCategoryFilter.label

      const isChildSelected = this.ancestorCategoryFilterIdsFor(
        this.currentCategoryFilter
      ).includes(this.categoryFilter.id)

      return isChildSelected ||
        this.currentCategoryFilter.id === this.categoryFilter.id // Scenario: When Select All Face is selected, display "Face" next to "Face >" filter
        ? this.currentCategoryFilter.label
        : ''
    },

    shouldRender() {
      if (!this.categoryFilter.children.length) return

      const currentTierCategoryFilter = this.categoryFilterTrail[this.tier]

      // Check categoryFilterTrail first in order to prevent incorrect behaviour due to undefined === undefined
      return (
        currentTierCategoryFilter &&
        currentTierCategoryFilter?.id === this.categoryFilter?.id
      )
    }
  },

  methods: {
    categoryFilterAction() {
      this.categoryFilter.isSelectable
        ? this.selectCategoryFilter()
        : this.addToCategoryFilterTrail()
    },

    addToCategoryFilterTrail() {
      this.$store.commit(
        'listingPageFilters/setListingPageCategoryFilterTrail',
        { push: this.categoryFilter }
      )
    },

    selectCategoryFilter() {
      this.navigateToCategory(this.categoryFilter.slugUrl)

      if (this.entityType === 'category') {
        this.$store.commit('listingPageFilters/setShowFiltersMobile', false)
        this.$store.commit(
          'listingPageFilters/setListingPageCategoryFilterTrail',
          { clear: true }
        )
      } else {
        this.$store.commit(
          'listingPageFilters/setListingPageCurrentCategoryFilter',
          this.categoryFilter
        )

        // if View Results CTA Button is already displayed do nothing
        if (!this.showViewResultsCTAButton) {
          this.$store.commit(
            'listingPageFilters/setShowViewResultsCTAButton',
            true
          )
        }
      }
    }
  }
}
</script>
